import React, { useState } from "react";
import Loader from "../../components/loader/index";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.css";

const SignUp = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  return (
    <>
      <div
        className={`container col-md-7 col-lg-6 p-1 d-flex justify-content-center align-items-center ${styles.height_100}`}
      >
        <div
          className="adminLogin w-100 border border-0 rounded-5 p-sm-3 p-3 px-md-5 shadow-lg"
          style={{
            backgroundImage: `url(${require("../../assets/images/OTP.png")})`,
            backgroundSize: "contain",
            backgroundPosition: "bottom center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <h4 className="fw-bold text-center">Sign Up</h4>
          <p className="signUp text-center fs_12">
            Enter the information you entered while registering
          </p>
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          <form className="mx-auto w-100 row">
            <div className="mb-md-3 mb-sm-0 col-sm-12 col-md-6 p-1">
              <label htmlFor="name" className="form-label fs_12 fw-bold">
                Name *
              </label>
              <input
                type="text"
                className="form-control w-100"
                id="name"
                aria-describedby="emailHelp"
                name="name"
                required
              />
              <label htmlFor="email" className="form-label fs_12 fw-bold">
                Email Address *
              </label>
              <input
                type="email"
                className="form-control w-100"
                id="email"
                aria-describedby="emailHelp"
                name="email"
                required
              />
              <label htmlFor="country" className="form-label fs_12 fw-bold">
                Country *
              </label>
              <input
                type="text"
                className="form-control w-100"
                id="country"
                aria-describedby="emailHelp"
                name="country"
                required
              />
              <label htmlFor="address" className="form-label fs_12 fw-bold">
                Address *
              </label>
              <input
                type="text"
                className="form-control w-100"
                id="address"
                aria-describedby="emailHelp"
                name="address"
                required
              />
              <label htmlFor="postalCode" className="form-label fs_12 fw-bold">
                Postal Code *
              </label>
              <input
                type="text"
                className="form-control w-100"
                id="postalCode"
                aria-describedby="emailHelp"
                name="postalCode"
                required
              />
            </div>

            <div className="mb-3 col-sm-12 col-md-6 p-1">
              <label htmlFor="fatherName" className="form-labe fs_12 fw-bold">
                Father Name *
              </label>
              <input
                type="text"
                className="form-control w-100"
                id="fatherName"
                name="fatherName"
                required
              />
              <label htmlFor="phone" className="form-labe fs_12 fw-bold">
                Phone *
              </label>
              <input
                type="text"
                className="form-control w-100"
                id="phnoe"
                name="phone"
                required
              />
              <label htmlFor="city" className="form-labe fs_12 fw-bold">
                City *
              </label>
              <input
                type="text"
                className="form-control w-100"
                id="city"
                name="city"
                required
              />
              <label
                htmlFor="NIC/Passport/Licence"
                className="form-labe fs_12 fw-bold"
              >
                NIC/Passport/Licence *
              </label>
              <input
                type="text"
                className="form-control w-100"
                id="NIC/Passport/Licence"
                name="NIC/Passport/Licence"
                required
              />
              <label htmlFor="password" className="form-labe fs_12 fw-bold">
                Password *
              </label>
              <input
                type="password"
                className="form-control w-100"
                id="password"
                name="password"
                required
              />
            </div>
            {/* <div className="mb-3 form-check">
              <input
                type="checkbox"
                className="form-check-input my-1 d-none"
                id="exampleCheck1"
              />
              <div className="d-flex justify-content-between">
                <label
                  className="form-check-label fs_12 my-1"
                  htmlFor="exampleCheck1"
                ></label>
                <a
                  className="forgotpassword fs_12 my-1 link-dark text-decoration-none"
                  href="/"
                >
                  Forget Password
                </a>
              </div>
            </div> */}
            <div className="px-1">
              <button
                disabled={loading}
                type="submit"
                className="btn btn-primary btn_contained d-grid gap-2 col-12 p-2"
              >
                {loading ? <Loader /> : "Sign Up"}
              </button>
            </div>
            <div className="signUpText mt-3 text-center fs_12">
              <p>
                Already have an account.{" "}
                <span
                  onClick={() => {
                    navigate("/");
                    console.log("Sign Up");
                  }}
                  className="link-dark text-decoration-none fw-bold cursor_pointer"
                >
                  Login
                </span>
              </p>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SignUp;
